<template>
  <div class="indication-link">
    <div class="container">
      <div class="board">
        <section v-if="!loggedIn" class="indication-link__guest">
          <h2 class="indication-link__title">
            Indique a Videomedi para amigos
          </h2>

          <p class="indication-link__text">
            A Videomedi é uma plataforma de telemedicina que conecta pacientes e
            profissionais de saúde para consultas online com segurança e
            praticidade.
          </p>

          <h3 class="indication-link__subtitle">Como funciona a indicação</h3>
          <ol class="indication-link__steps">
            <li>Entre na sua conta e acesse seu link pessoal de indicação.</li>
            <li>Compartilhe o link com amigos, familiares ou colegas.</li>
            <li>
              Ao se cadastrarem pelo seu link, ficam vinculados à sua indicação.
            </li>
          </ol>

          <h3 class="indication-link__subtitle">
            O que o convidado precisa fazer
          </h3>
          <p class="indication-link__text">
            A pessoa indicada abre o link que você enviou, cria uma conta na
            Videomedi e passa a usar a plataforma normalmente. O cadastro é
            feito pela página de registro — não é necessário informar código
            manualmente.
          </p>

          <RouterLink class="indication-link__cta" :to="loginRoute">
            <BaseButton size="lg">
              Entrar para ver meu link
            </BaseButton>
          </RouterLink>
        </section>

        <section v-else class="indication-link__logged">
          <h2 class="indication-link__title">Seu link de indicação</h2>

          <p class="indication-link__text">
            Copie e envie o link abaixo para alguém que queira se tornar cliente
            da nossa plataforma.
          </p>

          <div class="indication-link__field">
            <label class="indication-link__label">Seu código</label>
            <input
              type="text"
              class="indication-link__input"
              :value="currentUser.code"
              readonly
            />
          </div>

          <div class="indication-link__field">
            <label class="indication-link__label">Link de indicação</label>
            <input
              type="text"
              class="indication-link__input"
              :value="currentUser.indication_link"
              readonly
            />
          </div>

          <div
            v-if="currentUser.indication_link"
            class="indication-link__actions"
          >
            <BaseButton size="lg" @click="copyLink">
              Copiar link
            </BaseButton>
            <BaseButton
              v-if="canShare"
              variant="light"
              size="lg"
              @click="shareLink"
            >
              Compartilhar
            </BaseButton>
          </div>

          <p v-if="linkCopied" class="indication-link__copied-msg">
            Link copiado!
          </p>

          <p class="indication-link__hint">
            Ao abrir este link, a pessoa será redirecionada para a página de
            cadastro, onde poderá se registrar na Videomedi.
          </p>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "IndicationLinkView",

  data() {
    return {
      linkCopied: false,
      copyFeedbackTimeout: null
    };
  },

  mounted() {
    if (this.loggedIn && this.currentUser.id) {
      this.$store.dispatch("user/showUser", this.currentUser.id);
    }
  },

  beforeDestroy() {
    if (this.copyFeedbackTimeout) {
      clearTimeout(this.copyFeedbackTimeout);
    }
  },

  methods: {
    showCopyFeedback() {
      this.linkCopied = true;

      if (this.copyFeedbackTimeout) {
        clearTimeout(this.copyFeedbackTimeout);
      }

      this.copyFeedbackTimeout = setTimeout(() => {
        this.linkCopied = false;
      }, 3000);
    },

    async copyLink() {
      const link = this.currentUser.indication_link;
      if (!link) return;

      await navigator.clipboard.writeText(link);
      this.showCopyFeedback();
    },

    async shareLink() {
      const link = this.currentUser.indication_link;
      if (!link) return;

      try {
        await navigator.share({
          title: "Videomedi",
          text: "Cadastre-se na Videomedi pelo meu link de indicação:",
          url: link
        });
      } catch (error) {
        if (error.name === "AbortError") return;

        await this.copyLink();
      }
    }
  },

  computed: {
    ...mapGetters("auth", ["loggedIn"]),

    currentUser() {
      return this.$store.getters["user/getCurrentUser"];
    },

    loginRoute() {
      return {
        name: "Login",
        query: { redirectFrom: "/indicar-para-amigos" }
      };
    },

    canShare() {
      return typeof navigator !== "undefined" && !!navigator.share;
    }
  }
};
</script>
